<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body mb-8 text-center">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="mt-0 font-bold"
          v-text="'Delete Membership'"
        />
      </header>
      <div>
        <div class="flex justify-center items-baseline mt-4">
          <p v-text="'Are you sure you want to delete this membership? You cannot undo this action.'" />
        </div>
      </div>
    </div>
    <div class="modal-footer text-center mt-4">
      <button
        type="button"
        class="btn btn--danger"
        @click.prevent="deleteMembership"
        v-text="'Delete'"
      />
      <a
        href="#"
        class="mx-4"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'DeleteMembershipModal',
  computed: {
    membership() {
      return this.$store.state.membership.deleteMembershipModal.membership
    },
    show() {
      return this.$store.state.membership.deleteMembershipModal.open
    },
  },
  methods: {
    deleteMembership() {
      this.$api.active().delete(`memberships/${this.membership.uuid}`)
        .then(() => {
          this.$emit('membershipHasBeenDeleted')

          this.$store.commit('baseAddNotification', {
            type: 'success',
            text: 'Membership was successfully deleted!',
          })

          this.close()
        }).catch(() => {
          this.$store.commit('baseAddNotification', {
            type: 'error',
            text: 'There was a problem deleting the membership.',
            timeout: false,
          })

          this.close()
        })
    },
    close() {
      this.$store.commit('membershipCloseDeleteMembershipModal')
    },
  },
}
</script>
